const STATS = [
  { value: "6年", label: "稳定运营" },
  { value: "1200+", label: "在线作品" },
  { value: "500+", label: "完结大结局" },
  { value: "98.6%", label: "读者好评率" },
];

const TESTIMONIALS = [
  {
    name: "小鹿同学",
    role: "铁杆追更读者",
    content:
      "在89890漫画网把《青梅竹马不断向我甜蜜求婚》大结局一口气看完了，画质超清晰，更新还特别快，完全免费，真的太良心了！",
  },
  {
    name: "阿桃",
    role: "甜宠漫画爱好者",
    content:
      "分类很全，甜宠和校园漫画都特别好找，阅读器很流畅，手机上看着也很舒服，已经安利给室友啦。",
  },
  {
    name: "南风知我意",
    role: "三年老读者",
    content:
      "从2019年就在这里看漫画了，平台一直坚持免费阅读，客服响应也很快，希望继续做下去，支持！",
  },
];

export default function ReputationSection() {
  return (
    <section className="bg-background-100/70 py-12 md:py-16" aria-labelledby="reputation-title">
      <div className="container-site">
        <div className="flex flex-col items-center text-center">
          <span className="chip-tag">口碑评价</span>
          <h2 id="reputation-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            读者口碑，是最好的证明
          </h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            六年坚持免费阅读，我们用服务和作品赢得了千万读者的信任。
          </p>
        </div>

        <dl className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4 md:gap-5">
          {STATS.map((item) => (
            <div
              key={item.label}
              className="rounded-lg border border-background-200/70 bg-background-50 p-5 text-center transition-transform duration-300 hover:-translate-y-1"
            >
              <dt className="sr-only">{item.label}</dt>
              <dd className="font-heading text-3xl font-bold text-primary-500">{item.value}</dd>
              <dd className="mt-1.5 text-sm text-foreground-600">{item.label}</dd>
            </div>
          ))}
        </dl>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
          {TESTIMONIALS.map((item) => (
            <figure
              key={item.name}
              className="flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-5"
            >
              <div className="flex items-center gap-0.5 text-sm text-accent-500">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill" aria-hidden="true" />
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                “{item.content}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-800">
                  {item.name.slice(0, 1)}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{item.name}</p>
                  <p className="text-xs text-foreground-600">{item.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}